/**
 * User-facing strings reused across multiple components. Centralized so
 * a copy edit stays in one place — the apply-blocked toast in particular
 * fires from four different code paths (Esc, in-editor Apply, breadcrumb
 * navigation, navigation guard) and they should always say the same thing.
 */

export const APPLY_BLOCKED_TOAST = "Can't apply yet — fix the highlighted issues first.";
